import React, { useEffect, useImperativeHandle } from "react";
import { Col, Divider, Form, Input, Row, Switch, TreeSelect, Select } from "antd";
import { useModel, useModelDispatchers } from "../../../models";
import { CM_ACTION_TYPE } from "../../../utils/constants";
import { goPage } from "../../layout/pageDefinition";
import { useHistory } from "react-router";

const tailLayout = {
    labelCol: { span: 3 }
};

const dataTransfer = (data) => {
    let formData = data;
    formData.detail = [];
    if (data.supplierPerson2 || data.supplierPhone2) {
        formData.detail.push({ supplierPerson: data.supplierPerson2, supplierPhone: data.supplierPhone2 });
    }
    if (data.supplierPerson3 || data.supplierPhone3) {
        formData.detail.push({ supplierPerson: data.supplierPerson3, supplierPhone: data.supplierPhone3 });
    }
    return formData;
};

export default function ({ formRef, actionType }) {
    const [{ supplierTypeDict, opnBankDict }, { getSupplierTypeDict, getAccountTypeDict, getOpnBankDict }] = useModel("cmDict");
    const [{ userInfo }] = useModel("global");
    const { closeNav } = useModelDispatchers("nav");
    const history = useHistory();
    useEffect(() => {
        getSupplierTypeDict();
        getAccountTypeDict()
        getOpnBankDict()

        // getAccountTyprDict();

        // getAccountTypeDict()
        // console.log(supplierDict)
    }, []);

    const [form] = Form.useForm();
    const [{ selectedSupplier }, { insert, update }] = useModel("supplier");

    useEffect(() => {
        if (actionType === CM_ACTION_TYPE.EDIT) {
            if (selectedSupplier) {
                form.setFieldsValue(selectedSupplier)
                const { supplierStatus } = selectedSupplier;
                form.setFieldsValue({ "supplierStatus": !!(supplierStatus == 0) });
                if (selectedSupplier.detail && selectedSupplier.detail.length > 0) {
                    form.setFieldsValue({ supplierPerson2: selectedSupplier.detail[0].supplierPerson })
                    form.setFieldsValue({ supplierPhone2: selectedSupplier.detail[0].supplierPhone })
                    if (selectedSupplier.detail.length > 1) {
                        form.setFieldsValue({ supplierPerson3: selectedSupplier.detail[1].supplierPerson })
                        form.setFieldsValue({ supplierPhone3: selectedSupplier.detail[1].supplierPhone })
                    }
                }
            }
        } else if (actionType === CM_ACTION_TYPE.INSERT) {
            form.setFieldsValue({ "supplierStatus": true });
        }
        // form.setFieldsValue({createUser:userInfo.userName,updateUser:userInfo.userName});

    }, [actionType, selectedSupplier])

    useImperativeHandle(formRef, () => ({
        form: () => {
            return form;
        },
        insert: () => {
            form.validateFields().then(datas => {
                let { supplierStatus } = datas
                if (supplierStatus == undefined || supplierStatus == true) {
                    supplierStatus = 0
                } else {
                    supplierStatus = 1
                }
                let data = {
                    ...datas,
                    orgId: userInfo.orgId,
                    orgName: userInfo.orgName,
                    supplierStatus,
                    updateTime: null,
                    supplierStatus: 0
                }
                insert({ data: dataTransfer(data) }).then(res => {
                    if (!!res) {
                        closeNav();
                        goPage(history, "6-3");
                    }
                });
            })
        },
        update: () => {
            let { id, orgId } = selectedSupplier
            form.validateFields().then(datas => {
                let data = {
                    ...datas,
                    updateTime: null,
                    id,
                    orgId: userInfo.orgId,
                    orgName: userInfo.orgName,
                }
                update({ data: dataTransfer(data) }).then(res => {
                    if (!!res) {
                        closeNav();
                        goPage(history, "6-3");
                    }
                })
            })
        },
        reset: () => {
            form.resetFields();
            if (actionType === CM_ACTION_TYPE.INSERT) {

            } else if (actionType === CM_ACTION_TYPE.EDIT) {
                let { supplierCode, createUser, createTime, updateUser, updateTime } = selectedSupplier
                form.setFieldsValue({ supplierCode, createUser, createTime, updateUser, updateTime });
            }
        },
    }));
    return (
        <Form
            form={form}
            name="material_detail"
            labelCol={{ span: 6 }}
        >

            {/*<Divider orientation="left" plain>基本信息</Divider>*/}

            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="supplierCode"
                        label="供应商编码"
                    >
                        <Input disabled={true} placeholder="供应商编码" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="supplierName"
                        label="供应商名称"
                        rules={[{ required: true, message: '请输入供应商名称' }]}
                    >
                        <Input placeholder="供应商名称" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="supplierType"
                        label="供应商类型"
                    >
                        <TreeSelect
                            showSearch
                            allowClear
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder="供应商类型"
                            treeDefaultExpandAll
                            onChange={() => {
                            }}
                            treeData={supplierTypeDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="supplierAddress"
                        label="联系地址"
                    >
                        <Input placeholder="联系地址" />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="supplierPerson"
                        label="联系人"
                    >
                        <Input placeholder="联系人" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="supplierPhone"
                        label="联系电话"
                    >
                        <Input placeholder="联系电话" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="supplierTelephone"
                        label="办公电话"
                    >
                        <Input placeholder="办公电话" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="supplierEmail"
                        label="电子邮箱"
                    >
                        <Input placeholder="电子邮箱" />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="supplierPerson2"
                        label="联系人2"
                    >
                        <Input placeholder="联系人2" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="supplierPhone2"
                        label="联系电话"
                    >
                        <Input placeholder="联系电话2" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="supplierFax"
                        label="传真号码"
                    >
                        <Input placeholder="传真号码" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="supplierWebsite"
                        label="公司网址"
                    >
                        <Input placeholder="公司网址" />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="supplierPerson3"
                        label="联系人3"
                    >
                        <Input placeholder="联系人3" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="supplierPhone3"
                        label="联系电话"
                    >
                        <Input placeholder="联系电话" />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="supplierDesc"
                        label="备注"
                        {...tailLayout}
                    >
                        <Input placeholder="备注" />
                    </Form.Item>
                </Col>
            </Row>

            <Divider orientation="left" plain>开票信息</Divider>

            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="invoiceTitle"
                        label="发票抬头"
                    >
                        <Input placeholder="发票抬头" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="businessLicense"
                        label="营业执照"
                    >
                        <Input placeholder="营业执照" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="supplierBankAcctName"
                        label="开户银行"
                    >
                        {/* <Input placeholder="开户银行"/> */}
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="开户银行"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={opnBankDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="supplierBankAccount"
                        label="银行账号"
                    >
                        <Input placeholder="银行账号" />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="mailingAddress"
                        label="邮寄地址"
                    >
                        <Input placeholder="邮寄地址" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="legalPerson"
                        label="公司法人"
                    >
                        <Input placeholder="公司法人" />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="businessScope"
                        label="经营范围"
                        {...tailLayout}
                    >
                        <Input placeholder="经营范围" />
                    </Form.Item>
                </Col>
            </Row>

            <Divider orientation="left" plain>其他信息</Divider>

            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="createUser"
                        label="创建人"
                    >
                        <Input disabled={true} placeholder="创建人" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="createTime"
                        label="创建时间"
                    >
                        <Input disabled={true} placeholder="创建时间" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="updateUser"
                        label="修改人"
                    >
                        <Input disabled={true} placeholder="修改人" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="updateTime"
                        label="修改时间"
                    >
                        <Input disabled={true} placeholder="修改时间" />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="supplierStatus"
                        label="是否启用"
                        valuePropName="checked"
                    >
                        <Switch size="default" />
                    </Form.Item>
                </Col>
                <Col span={18}>
                </Col>
            </Row>
        </Form>
    )
}